import { render, staticRenderFns } from "./islem.vue?vue&type=template&id=f5ba8620"
import script from "./islem.vue?vue&type=script&lang=js"
export * from "./islem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports